import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9bc80590&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bc80590')) {
      api.createRecord('9bc80590', component.options)
    } else {
      api.reload('9bc80590', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9bc80590&", function () {
      api.rerender('9bc80590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-renderer/exam/Question/index.vue"
export default component.exports